import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
  standalone: false
})
export class LayoutComponent implements OnInit, OnDestroy {
  currentDate = '';
  activeTab = 'Bigg Boss';
  private timerId: any;

  ngOnInit(): void {
    this.updateClock();
    this.timerId = setInterval(() => {
      this.updateClock();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }

  updateClock(): void {
    const date = new Date();
    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const day = date.getDate();
    const year = date.getFullYear();
    const time = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
    this.currentDate = `${weekday} ${month} ${day} ${year} ${time}`;
  }

  setActiveTab(tabName: string): void {
    this.activeTab = tabName;
  }
}
